// extracted by mini-css-extract-plugin
export default {"pointer":"pointer_pointer__0shSu","spin":"pointer_spin__uJjks"};